import React from 'react';
import {
  createFrontendModule,
  PageBlueprint,
  useApi,
} from '@backstage/frontend-plugin-api';
import { compatWrapper, convertLegacyRouteRef } from '@backstage/core-compat-api';
import {
  AsyncEntityProvider,
  catalogApiRef,
  entityRouteRef,
} from '@backstage/plugin-catalog-react';
import useAsyncRetry from 'react-use/esm/useAsyncRetry';
import { useParams } from 'react-router-dom';
import { entityPage } from '../components/catalog/EntityPage';

const catalogEntityRouteRef = convertLegacyRouteRef(entityRouteRef);

const LegacyEntityPage = () => {
  const { kind = '', namespace = '', name = '' } = useParams<{
    kind: string;
    namespace: string;
    name: string;
  }>();
  const catalogApi = useApi(catalogApiRef);

  const { value: entity, error, loading, retry: refresh } = useAsyncRetry(
    () => catalogApi.getEntityByRef({ kind, namespace, name }),
    [catalogApi, kind, namespace, name],
  );

  return (
    <AsyncEntityProvider
      entity={entity}
      loading={loading}
      error={error}
      refresh={refresh}
    >
      {entityPage}
    </AsyncEntityProvider>
  );
};

export const catalogEntityCompatModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    PageBlueprint.make({
      name: 'entity',
      params: {
        path: '/catalog/:namespace/:kind/:name',
        routeRef: catalogEntityRouteRef,
        loader: async () => compatWrapper(<LegacyEntityPage />),
      },
    }),
  ],
});
